export const DEVICE_MANUFACTURER_HUAWEI = "huawei";
export const DEVICE_MANUFACTURER_ZTE = "zte";
export const DEVICE_MANUFACTURER_KAONMEDIA = "kaonmedia";

export const DEVICES_IPTV = [DEVICE_MANUFACTURER_HUAWEI, DEVICE_MANUFACTURER_ZTE, DEVICE_MANUFACTURER_KAONMEDIA];



// WEBPACK FOOTER //
// ./src/requests/tasks/constants.js